import React, { useEffect } from 'react'

import { generateHtmlFromJSON } from '@pepper/docs/src/utils/functions/htmlGeneratorFromJSON'
import '@pepper/docs/src/styles/editor.css'
import { Empty } from '../../atoms'

import { ReactComponent as LoaderIcon } from '../../assets/loader.svg'

import { useGetBriefContent } from '../../hooks'
import styles from './_.module.css'

interface Props {
  pepperDocId: string
}

const BriefContent: React.FC<Props> = ({ pepperDocId }) => {
  const briefContent = useGetBriefContent({
    data: { pepperDocId }
  })

  if (briefContent.isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <div className={styles.loaderIconContainer}>
          <LoaderIcon className={styles.loaderIcon} />
        </div>
        <div className={styles.loadingText}>
          Please wait while we load the Brief..
        </div>
      </div>
    )
  }

  return (
    <>
      {briefContent?.data?.content.html === '' ? (
        <Empty className={styles.blankCanvas} />
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: generateHtmlFromJSON(briefContent.data?.content.json)
          }}
          className={styles.briefHTML}
        />
      )}
    </>
  )
}

export default BriefContent
